export default __webpack_public_path__ + "static/media/gather-chat.93c755f3.png";